import PropTypes from 'prop-types';

export const pointsMaskToPix = (value = 0, decimalPlaces = 0) => {
    const parsedValue = Number(value);

    let formattedValue;
    if (decimalPlaces === 0) {
        const truncValue = Math.trunc(parsedValue).toString();
        formattedValue = truncValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else {
        formattedValue = parsedValue.toFixed(decimalPlaces);
        formattedValue = formattedValue.replace('.', ',');
        formattedValue = formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    return formattedValue;
};

export const pointsMask = (value = 0, decimalPlaces = 0, pointsLabel = '') => {
    const parsedValue = Number(value);

    let formattedValue;
    if (decimalPlaces === 0) {
        const trucncValue = Math.trunc(parsedValue).toString();
        formattedValue = trucncValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else {
        formattedValue = parsedValue.toFixed(decimalPlaces);
        formattedValue = formattedValue.replace('.', ',');
        formattedValue = formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    return {
        value: formattedValue,
        label: pointsLabel,
    };
};

pointsMask.propTypes = {
    value: PropTypes.number.isRequired,
    decimalPlaces: PropTypes.number.isRequired,
    pointsLabel: PropTypes.string.isRequired,
};
